// Addons data constants
export const ADD_ON = {
  entitlements: {
    'Custom Video': {
      label: 'Custom Video',
    },
  },
}
